type Message = "GET_AUTH_TOKENS" | "AUTH_TOKENS_RESPONSE" | "CLOSE_WEBVIEW";

interface ReactNativeWebViewMessageResponse {
	data: any;
	message: Message;
}

const activeListeners = new Map<
	Message,
	{ window: (e: MessageEvent) => void; document: (e: Event) => void }
>();

const handleEventReceived = (
	event: MessageEvent | Event,
	expectedMessage: Message,
	cb?: (data: any) => void
) => {
	if (
		"origin" in event &&
		event.origin &&
		event.origin !== "null" &&
		event.origin !== window.location.origin
	)
		return;

	try {
		const raw = "data" in event ? event.data : undefined;
		if (typeof raw !== "string") return;

		const { message, data } = JSON.parse(
			raw
		) as ReactNativeWebViewMessageResponse;
		if (message !== expectedMessage) return;
		cb && cb(data);
	} catch {
		// malformed message — ignore
	}
};

const WebViewMessageEventEmitter = {
	emit: (message: Message) => {
		if (!window.ReactNativeWebView) return;
		window.ReactNativeWebView.postMessage(JSON.stringify({ message }));
	},

	addListener: (eventMessage: Message, cb: (data: any) => void) => {
		WebViewMessageEventEmitter.removeEventListener(eventMessage);

		const windowHandler = (event: MessageEvent) =>
			handleEventReceived(event, eventMessage, cb);
		const documentHandler = (event: Event) =>
			handleEventReceived(event as MessageEvent, eventMessage, cb);

		activeListeners.set(eventMessage, {
			window: windowHandler,
			document: documentHandler
		});

		window.addEventListener("message", windowHandler);
		document.addEventListener("message", documentHandler);
	},

	removeEventListener: (eventMessage: Message) => {
		const handlers = activeListeners.get(eventMessage);
		if (!handlers) return;

		window.removeEventListener("message", handlers.window);
		document.removeEventListener("message", handlers.document);
		activeListeners.delete(eventMessage);
	}
};

export default WebViewMessageEventEmitter;
